import script from "./CustomAlert.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomAlert.vue?vue&type=script&lang=ts&setup=true"

import "./CustomAlert.vue?vue&type=style&index=0&id=aa4ee0ec&lang=css"

const __exports__ = script;

export default __exports__